module.exports = __webpack_public_path__ + "static/img/ice_hockey.7f1623e.jpg";